import axios from "axios";

const baseURL =
  (import.meta as any).env?.VITE_BASE_URL || "https://codematic-hackathon-backend-749119130796.europe-west1.run.app";

const axiosInstance = axios.create({
  baseURL,
});

// Add request interceptor to include auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
  (response) => {
    // Check for authentication errors in successful responses (API returns { success: false })
    if (response.data && response.data.success === false) {
      const message = response.data.message || response.data.error || "";

      if (
        message.toLowerCase().includes("invalid") ||
        message.toLowerCase().includes("expired") ||
        message.toLowerCase().includes("unauthorized")
      ) {
        localStorage.removeItem("adminToken");

        if (!window.location.pathname.includes("/login")) {
          window.location.replace("/login");
        }

        return Promise.reject(new Error(message));
      }
    }

    return response;
  },
  (error) => {
    const status = error.response?.status;

    if (status === 401 || status === 400 || status === 404) {
      // Token expired, invalid, or profile endpoint missing
      localStorage.removeItem("adminToken");

      if (!window.location.pathname.includes("/login")) {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

export { axiosInstance };
